/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DaysOfWeekMask = 0 | 1 | 2 | 4 | 8 | 16 | 32 | 64 | 127;

export const DaysOfWeekMask = {

    NUMBER_0: 0 as DaysOfWeekMask,

    NUMBER_1: 1 as DaysOfWeekMask,

    NUMBER_2: 2 as DaysOfWeekMask,

    NUMBER_4: 4 as DaysOfWeekMask,

    NUMBER_8: 8 as DaysOfWeekMask,

    NUMBER_16: 16 as DaysOfWeekMask,

    NUMBER_32: 32 as DaysOfWeekMask,

    NUMBER_64: 64 as DaysOfWeekMask,

    NUMBER_127: 127 as DaysOfWeekMask
};

